import { Box, Skeleton, styled, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { CSSProperties } from 'styled-components';

const StyledKey = styled(Box)`
  display: flex;
  background-color: var(--neutral-400);
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  padding: 16px;
  color: var(--gray-800);
  align-items: center;
`;

const StyledValue = styled(Box)`
  display: flex;
  background-color: var(--base-white);
  border-left: 1px solid var(--neutral-500);
  padding: 16px;
  flex: 1;
`;

type FieldBoxPropertyProps = {
  name: string;
  value: string | ReactNode;
  type?: 'text' | ReactNode;
  keyStyle?: CSSProperties;
  isLoading?: boolean
};

const FieldBoxProperty: FC<FieldBoxPropertyProps> = ({
  name,
  value,
  type,
  keyStyle,
  isLoading = false,
}) => {
  return (
    <Box
      display="flex"
      sx={{
        borderBottom: '1px solid var(--neutral-500)',
        '&:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <StyledKey sx={{ minWidth: '180px', maxWidth: '180px', ...keyStyle }}>
        {name}
      </StyledKey>
      <StyledValue>
        {isLoading
          ? <Skeleton width={'100%'} height={'25px'} />
          : type === 'text'
            ? (
              <Typography component={'span'} variant="body1" color="var(--gray-800)" >
                {value}
              </Typography>
            )
            :
            value
        }
      </StyledValue>
    </Box>
  );
};

export default FieldBoxProperty;
